module.exports = __webpack_public_path__ + "img/cs.6ddaf2c5.png";